// leinwand.js — der Weg zur Anzeige unter /formen-display.
//
// Beide Schreiber-Panels (Formen und Selbstverteidigung) senden hierueber, und
// zwar auf zwei Wegen gleichzeitig: localStorage erreicht andere Fenster und
// ueberlebt deren Reload, BroadcastChannel erreicht denselben Tab.
//
// Die Anzeige rechnet nichts. Sie zeigt, was hier ankommt.

export const LEINWAND_KANAL = 'tda-formen-display';
export const LEINWAND_SPEICHER = 'tda-formen-display-state';
export const LEINWAND_ADRESSE = '/formen-display';

/** Nur die Felder, die auf der Leinwand vorkommen. Geburtsdatum und alles
 *  weitere Personenbezogene hat in localStorage nichts zu suchen. */
export const schlankerTeilnehmer = (tn) => tn && ({
  wettkaempfer_id: tn.wettkaempfer_id,
  startnummer: tn.startnummer,
  vorname: tn.vorname,
  nachname: tn.nachname,
  verein_name: tn.verein_name,
  gurtfarbe: tn.gurtfarbe,
});

export const schlankeRangliste = (liste) => (liste || []).map(tn => ({
  wettkaempfer_id: tn.wettkaempfer_id,
  vorname: tn.vorname,
  nachname: tn.nachname,
  verein_name: tn.verein_name,
  gesamt_punkte: tn.gesamt_punkte,
  status: tn.status,
  platzierung: tn.platzierung,
}));

export function sendeAnLeinwand(paket) {
  const roh = JSON.stringify({ ...paket, gesendet: Date.now() });
  try { localStorage.setItem(LEINWAND_SPEICHER, roh); } catch (e) { /* privater Modus */ }
  try {
    const kanal = new BroadcastChannel(LEINWAND_KANAL);
    kanal.postMessage(JSON.parse(roh));
    setTimeout(() => kanal.close(), 200);
  } catch (e) { /* aeltere Browser: localStorage genuegt */ }
}

/** Leinwand oeffnen — moeglichst gleich auf dem zweiten Bildschirm.
 *  Muster aus ErgebnisDashboard (Siegerehrung), inklusive der Eigenheiten von
 *  Firefox und Safari. */
export async function oeffneLeinwand() {
  const name = 'formen-display';

  if ('getScreenDetails' in window && window.screen?.isExtended) {
    try {
      const schirme = await window.getScreenDetails();
      const zweiter = schirme.screens.find(s => !s.isPrimary);
      if (zweiter) {
        window.open(LEINWAND_ADRESSE, name,
          `popup,left=${zweiter.availLeft},top=${zweiter.availTop},width=${zweiter.availWidth},height=${zweiter.availHeight}`);
        return true;
      }
    } catch (e) { /* weiter mit dem Fallback */ }
  }

  const breite = window.screen.width;
  const hoehe = window.screen.availHeight || window.screen.height;
  const links = /Firefox/.test(navigator.userAgent) ? breite : undefined;
  const fenster = window.open(LEINWAND_ADRESSE, name,
    `popup,${links !== undefined ? `left=${links},top=0,` : ''}width=${breite},height=${hoehe},menubar=no,toolbar=no,location=no,status=no`);
  if (!fenster) {
    alert('Das Fenster wurde vom Browser blockiert. Bitte Pop-ups für diese Seite erlauben.');
    return false;
  }
  if (links !== undefined) { try { setTimeout(() => fenster.moveTo(links, 0), 100); } catch (e) {} }
  return true;
}

export function kopiereLeinwandAdresse() {
  const adresse = `${window.location.origin}${LEINWAND_ADRESSE}`;
  return navigator.clipboard.writeText(adresse).then(() => adresse);
}
